export default __webpack_public_path__ + "static/media/Artboard 3.074872d4.png";